var zIndices = {
  displayOverContent: 10000,
  orbitMenu: 20000,
  modalReview: 50000,
};
export default zIndices;
